import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlay, faDownload } from "@fortawesome/free-solid-svg-icons";
import VideoPlayer from "../VideoPlayer";

export default function AthleteMeasurementVideoViewer({
  title,
  label = "Overhead Squat Video",
  videoUrls = [],
  hasSubscriptionAccess = true,
  onBlock,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleDownload = async () => {
    if (!videoUrls[0]) return;
    setIsDownloading(true);
    try {
      const blob = await (await fetch(videoUrls[0])).blob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "video.mp4";
      a.click();

      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (err) {
      console.error("Download error:", err);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      <div className="pt-0.5 flex items-center">
        <FontAwesomeIcon
          icon={faCirclePlay}
          className={`text-xl pr-2 ${
            videoUrls.length > 0
              ? "text-blue-600 cursor-pointer"
              : "text-gray-400 cursor-not-allowed"
          }`}
          onClick={
            videoUrls.length > 0
              ? hasSubscriptionAccess
                ? openModal
                : onBlock
              : undefined
          }
        />
        <span className="text-[14px] text-gray-600 font-normal ">{label}</span>
        {isOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="absolute inset-0 bg-black opacity-50" />
            <div className="bg-white rounded-lg shadow-lg z-50 w-full max-w-5xl min-h-[auto] lg:min-h-[500px] p-4 m-2 overflow-y-auto">
              <div className="flex justify-between items-center mb-1">
                <div className="text-lg font-bold text-gray-800 flex">
                  {title}
                  <div className="pl-16 font-normal">
                    {videoUrls.length > 0 && (
                      <button
                        onClick={handleDownload}
                        disabled={isDownloading}
                        className={`ml-2 px-3 py-1 rounded text-sm flex items-center gap-2 ${
                          isDownloading
                            ? "text-gray-400 cursor-not-allowed"
                            : "text-gray-600 hover:text-black"
                        } bg-transparent`}
                      >
                        {isDownloading ? "Downloading..." : "Download"}
                        <FontAwesomeIcon
                          icon={faDownload}
                          className="text-gray-500"
                        />
                      </button>
                    )}
                  </div>
                </div>

                <button
                  onClick={closeModal}
                  className="text-gray-600 hover:text-black text-base font-bold safari-text"
                >
                  ✕
                </button>
              </div>
              <div className="flex flex-wrap gap-4 justify-center pt-2">
                {videoUrls.map((url, idx) => (
                  <VideoPlayer
                    key={idx}
                    src={url}
                    width="100%"
                    height="480px"
                    overlay={false}
                  />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
